import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'filterWith' })
export class FilterWithPipe implements PipeTransform {
  transform(input: any, filterWithFunc: (item: any) => boolean, _updated?: string | number): any[] {
    return Array.isArray(input) ? input.filter(e => filterWithFunc(e)) : input;
  }
}
